import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 14l5-5 5 5H7z"
}), 'ArrowDropUpTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowDropUpTwoTone.js
// module id = 2097
// module chunks = 2